/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Lifecycle status of a bundle group:
 * - `open`: created, no checkin started yet
 * - `checkin_started`: a Basic checkin has been started for the group
 * - `checkin_finished`: the checkin has been finished (signed)
 */
export enum BundleGroupStatusType {
  Open = 'open',
  CheckinStarted = 'checkin_started',
  CheckinFinished = 'checkin_finished'
}
